import { t } from '@moovly/i18n';
import { Button, useModal } from '@moovly/ui';
import * as React from 'react';
import CreateFontModal from '../modals/CreateFontModal';

interface FontCreateButtonContainerProps {
  label?: string;
}

const FontCreateButtonContainer: React.FC<FontCreateButtonContainerProps> = ({ label = t('fonts.create.button') }) => {
  const { isOpen, openModal, ...otherModalProps } = useModal();

  return (
    <>
      <Button onClick={openModal} label={label} />
      {isOpen && <CreateFontModal {...otherModalProps} />}
    </>
  );
};

export default FontCreateButtonContainer;
